"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperationName = exports.getClient = exports.BernieGraphqlClient = void 0;
var bernie_logger_1 = require("bernie-logger");
var fetch = require("isomorphic-fetch");
var graphql_tag_1 = require("graphql-tag");
var events_1 = require("./events");
var BernieGraphqlClient = /** @class */ (function () {
    function BernieGraphqlClient(config, logger) {
        if (logger === void 0) { logger = bernie_logger_1.NOOP_LOGGER; }
        this.uri = config.uri;
        this.headers = __assign({ 'Content-Type': 'application/json', credentials: 'same-origin', Connection: 'keep-alive' }, config.headers);
        this.logger = logger;
        this.request = this.request.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.logGraphQLErrors = this.logGraphQLErrors.bind(this);
        this.logNetworkErrors = this.logNetworkErrors.bind(this);
    }
    BernieGraphqlClient.prototype.mutate = function (data, requestOptions) {
        var mutation = data.mutation, variables = data.variables;
        var operationName = (0, exports.getOperationName)(mutation);
        return this.request({
            operationName: operationName,
            query: mutation,
            variables: variables,
        }, this.createHeadersFromRequestOptions(requestOptions));
    };
    BernieGraphqlClient.prototype.query = function (data, requestOptions) {
        var query = data.query, variables = data.variables;
        var operationName = (0, exports.getOperationName)(query);
        return this.request({ operationName: operationName, query: query, variables: variables }, this.createHeadersFromRequestOptions(requestOptions));
    };
    BernieGraphqlClient.prototype.request = function (body, extraHeaders) {
        var _this = this;
        var operationName = body.operationName, query = body.query, variables = body.variables;
        var headersToSend = new Headers(this.headers);
        Object.entries(extraHeaders || {}).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            headersToSend.set(key, value);
        });
        return fetch(this.uri, {
            method: 'POST',
            headers: headersToSend,
            credentials: 'same-origin',
            cache: 'no-cache',
            body: JSON.stringify({ operationName: operationName, query: query, variables: variables }),
        })
            .then(function (response) { return _this.handleResponse(response); })
            .then(function (response) { return _this.logGraphQLErrors(response); });
    };
    BernieGraphqlClient.prototype.createHeadersFromRequestOptions = function (requestOptions) {
        var extraHeaders = requestOptions && requestOptions.extraHeaders ? __assign({}, requestOptions.extraHeaders) : {};
        // eslint-disable-next-line no-magic-numbers
        if (requestOptions && requestOptions.pageId && requestOptions.pageId.length > 1) {
            extraHeaders['x-page-id'] = requestOptions.pageId;
        }
        // eslint-disable-next-line no-magic-numbers
        if (requestOptions && requestOptions.traceId && requestOptions.traceId.length > 1) {
            extraHeaders['trace-id'] = requestOptions.traceId;
        }
        // eslint-disable-next-line no-magic-numbers
        if (requestOptions && requestOptions.messageId && requestOptions.messageId.length > 1) {
            extraHeaders['message-id'] = requestOptions.messageId;
        }
        // eslint-disable-next-line no-magic-numbers
        if (requestOptions && requestOptions.debugTrace && requestOptions.debugTrace.length > 1) {
            extraHeaders['debug-trace'] = requestOptions.debugTrace;
        }
        return extraHeaders;
    };
    BernieGraphqlClient.prototype.handleResponse = function (response) {
        // eslint-disable-next-line no-magic-numbers
        if (response.status >= 400) {
            this.logNetworkErrors(new Error("Status code: ".concat(response.status)));
        }
        return Promise.resolve()
            .then(function () { return response.json(); })
            .then(function (json) {
            return {
                body: json,
                headers: response.headers,
            };
        });
    };
    BernieGraphqlClient.prototype.logGraphQLErrors = function (response) {
        var _this = this;
        var errors = (response && response.body && response.body.errors) || [];
        if (response && errors && errors.length > 0 && this.logger && typeof this.logger.logEvent === 'function') {
            errors.forEach(function (error) {
                _this.logger.logEvent(events_1.GRAPHQL_EVENTS.GRAPHQL_SERVICE_ERROR, error.message);
            });
        }
        return response;
    };
    BernieGraphqlClient.prototype.logNetworkErrors = function (error) {
        this.logger.logEvent(events_1.GRAPHQL_EVENTS.GRAPHQL_NETWORK_ERROR, error);
        throw error; // Re-throw to next catch.
    };
    return BernieGraphqlClient;
}());
exports.BernieGraphqlClient = BernieGraphqlClient;
var getClient = function (logger, clientOptions, requestHeaders) {
    if (logger === void 0) { logger = bernie_logger_1.NOOP_LOGGER; }
    var appName = clientOptions.appName, region = clientOptions.region, version = clientOptions.version, bexApiUrl = clientOptions.bexApiUrl;
    var clientInfo = "".concat(appName, ",").concat(version || 'pwa', ",").concat(region || 'external');
    var headers = __assign({ 'Client-Info': clientInfo }, requestHeaders);
    var apolloClientConfig = { headers: headers, uri: bexApiUrl };
    return new BernieGraphqlClient(apolloClientConfig, logger);
};
exports.getClient = getClient;
var getOperationName = function (gqlString) {
    var parsedString = gqlString && (0, graphql_tag_1.default)(gqlString);
    if (parsedString && parsedString.definitions && parsedString.definitions.length >= 0) {
        var operationDefinition = parsedString.definitions.find(function (item) { return item && item.kind === 'OperationDefinition'; }) || undefined;
        if (operationDefinition) {
            return (operationDefinition.name && operationDefinition.name.value) || '';
        }
    }
    return '';
};
exports.getOperationName = getOperationName;
//# sourceMappingURL=client.js.map